export default "__VITE_PUBLIC_ASSET__c6e97edc__"